export default __webpack_public_path__ + "locales/sl/Webhooks.json?hash=bad898c587193522f3fb7e1acfc53d56";